var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{attrs:{"forceFit":true,"height":_vm.height,"data":_vm.data,"scale":_vm.scale}},[_c('v-tooltip'),_c('v-axis'),_c('v-bar',{attrs:{"position":"year*sales"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }